"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MontageSetFormValidator = void 0;
const echain_shared_form_validation_1 = require("@igus/echain-shared-form-validation");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
class MontageSetFormValidator {
    static gewicht(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0,
        });
        const metricUnit = echain_shared_quantities_1.WeightUnits.kg;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0,
        });
        const imperialUnit = echain_shared_quantities_1.WeightUnits.lb;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
}
exports.MontageSetFormValidator = MontageSetFormValidator;
//# sourceMappingURL=MontageSetFormValidator.js.map